import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

import { TableContentFontSize } from '@/corePagesModule/BaseTableContent/interface/tableContentItems';
import { computed, ref } from 'vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'TableCell',
  props: {
    toolTipValue: { default: '' },
    textAlign: { default: 'left' },
    fontSize: { default: 'fontSizeSS' },
    isBorder: { type: Boolean, default: true }
  },
  emits: ["onClick"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "2c38e88b": (textAlign.value)
}))

const props = __props;

//textAlign
const textAlign = ref(props.textAlign);

//fontSizeの切り替え
const fontSizeClass = computed(() => {
  return props.fontSize;
});

//fontSizeの切り替え
const borderBottomClass = computed(() => {
  return props.isBorder ? 'border-bottom' : undefined;
});

// emits
const emits = __emit;

// 関数
/**
 * 文字列の長さによって、tooltip表示の有無を決める関数
 * @returns tooltip表示の有無
 */
const isDisplayTooltip = (): boolean => {
  if (!props.toolTipValue) return false;
  // 文字数の長さが26文字以上ならtrueを返す様にする
  // 文字数の全角半角カウントの処理は文字数の長さによって実行時間が長くなるため、回避策として追加
  if (props.toolTipValue.length === 26) return true;

  let count = 0; // 文字数カウント
  // 文字列を1文字ずつ全角半角判定を行う
  for (let i = 0, len = props.toolTipValue.length; i < len; i++) {
    // 改行コード判定
    if (props.toolTipValue[i].match(/^[^\x01-\x7E\uFF61-\uFF9F]+$/)) {
      // 全角判定
      count += 1;
    } else {
      // 半角判定
      count += 0.5;
    }
  }
  // 文字数カウントの切り上げ
  count = Math.ceil(count);

  // 文字数カウントが13以上ならtrueを返す
  if (count > 13) {
    return true;
  }
  return false;
};

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (isDisplayTooltip())
    ? _withDirectives((_openBlock(), _createElementBlock("td", {
        key: 0,
        class: _normalizeClass([[fontSizeClass.value, borderBottomClass.value], "body-cell"])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)), [
        [
          _directive_tooltip,
          props.toolTipValue,
          void 0,
          { bottom: true }
        ]
      ])
    : (_openBlock(), _createElementBlock("td", {
        key: 1,
        class: _normalizeClass([[fontSizeClass.value, borderBottomClass.value], "body-cell"])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
}
}

})